package com.dotdrives.web

import com.dotdrives.repository.RecoveryGrantStore
import kotlinx.browser.window

private const val RECOVERY_GRANT_PREFIX = "dotdrives.auth.recovery."

class SessionStorageRecoveryGrantStore : RecoveryGrantStore {
    override fun expiresAt(userId: String): Long? =
        runCatching {
            window.sessionStorage
                .getItem(storageKey(userId))
                ?.toLongOrNull()
        }.getOrNull()

    override fun save(userId: String, expiresAt: Long) {
        runCatching {
            window.sessionStorage.setItem(storageKey(userId), expiresAt.toString())
        }
    }

    override fun clear(userId: String) {
        runCatching {
            window.sessionStorage.removeItem(storageKey(userId))
        }
    }

    private fun storageKey(userId: String): String = "$RECOVERY_GRANT_PREFIX$userId"
}
